import { transformToEnergyPlotSchema } from "@/energyPlotView/types";
import { transformToLocationTableInput } from "@/locationTable/types";
import type { RootState } from "@/reducer";
import { hasTransientFallbackLayouts } from "@/utils/tabLayoutFallback";
import { transformToWeatherTableInput } from "@/weatherTableView/types";
import type { TabSnapshot } from "@mm/metx-workbench.meteomatics.com";

export type PresentTabState = RootState["tabGroup"]["present"];

export const buildTabSnapshot = (tabState: PresentTabState): TabSnapshot | null => {
  if (!tabState.tabMeta.data) {
    return null;
  }

  return {
    tab_meta: tabState.tabMeta.data,
    layouts: Object.values(tabState.layouts),
    maps: Object.values(tabState.maps),
    plots: Object.values(tabState.plots),
    energy_plots: Object.values(tabState.energyPlots).map((plot) =>
      transformToEnergyPlotSchema(plot, tabState.tabMeta.data.id_profile),
    ),
    weather_tables: Object.values(tabState.weatherTables).map((table) => transformToWeatherTableInput(table)),
    location_tables: Object.values(tabState.locationTables).map((table) => transformToLocationTableInput(table)),
    tephigrams: Object.values(tabState.tephigrams),
    country_plots: Object.values(tabState.countryPlots),
    notes: Object.values(tabState.notes),
    viewports: Object.values(tabState.viewports),
  };
};

export const hasUnsafeLayoutsForSnapshot = (tabSnapshot: TabSnapshot | null | undefined): boolean => {
  if (!tabSnapshot) {
    return false;
  }
  const layouts = Array.isArray(tabSnapshot.layouts) ? tabSnapshot.layouts : [];

  // A tab must always have at least one persisted layout; zero layouts or transient
  // (negative-id) fallback layouts are broken states that must never be saved.
  return layouts.length === 0 || hasTransientFallbackLayouts(layouts);
};
